import styles from "./SidebarLayout.module.css";
import { HEADER_HEIGHT } from "./constants";
import type { SplitPaneProps } from "@gfazioli/mantine-split-pane";
import { Split } from "@gfazioli/mantine-split-pane";
import { Box } from "@mantine/core";
import type { ReactNode } from "react";

export default function SidebarLayout({
  children,
  sidebar,
  sidebarSplitPaneProps
}: {
  children: ReactNode;
  sidebar: ReactNode;
  sidebarSplitPaneProps?: Partial<SplitPaneProps>;
}) {
  return (
    <Split h={`calc(100vh - ${HEADER_HEIGHT}px)`}>
      <Split.Pane grow h="100%">
        {children}
      </Split.Pane>
      <Split.Resizer size="sm" />
      <Split.Pane
        w="25vw"
        miw={400}
        maw={1000}
        h={`calc(100vh - ${HEADER_HEIGHT}px)`}
        style={{
          borderLeft: "solid 1px var(--mantine-color-disabled-border)",
          boxShadow: "var(--mantine-shadow-xs)"
        }}
        {...sidebarSplitPaneProps}
        // bg="rgba(255, 255, 255, 0.3)"
      >
        <Box w="100%" h="100%" p={5} className={styles.sidebarContent}>
          {sidebar}
        </Box>
      </Split.Pane>
    </Split>
  );
}
